<div class="header-wrapper">
  <div class="toolbar-wrapper">
    <h3 class="title-desktop">
      @if (currentIcon !== null) {
        <app-display-icon
          [icon]="currentIcon"
          class="icon"></app-display-icon>
      }
        {{ getTitle }}
    </h3>
    <div class="title-mobile">
      <app-icon-menu (click)="expandMenu($event)"></app-icon-menu>
      <div>
        @if (currentIcon !== null) {
          <app-display-icon
            [icon]="currentIcon"
            class="icon"></app-display-icon>
        }
        {{ getTitle }}
      </div>
    </div>

    <div class="end-slot-buttons" slot="end">

      <div class="banner-container">
        @if (!hideStoreSelector) {
          <div class="store-selector">
            @if (isMobile) {
              <div class="mobile-store-controls">
                @if (getMobileDisplayStore(); as displayStore) {
                  <app-shared-freshness-indicator-container
                    [currentStore]="displayStore"
                    [dataType]="'stock'"
                    class="mobile-freshness-indicator">
                  </app-shared-freshness-indicator-container>
                }
                <button
                  class="store-icon-button"
                  type="button"
                  [attr.aria-label]="allowsMultipleStoreSelection ? 'Select stores' : 'Select store'"
                  (click)="onMobileStoreClick()">
                  <app-display-icon [icon]="icons.storeOutline"></app-display-icon>
                </button>
              </div>
            } @else {
              <app-shared-custom-select
                (selectionChange)="onStoreSelectionChange($event)"
                [autoSubmitOnSelect]="true"
                [allowEmptySelection]="allowsMultipleStoreSelection"
                [allowMultiple]="allowsMultipleStoreSelection"
                [allowSelectAll]="allowsMultipleStoreSelection"
                [maxSelections]="storeSelectionLimit"
                [showSearchBar]="allowsMultipleStoreSelection && stores.length >= 8"
                [showChips]="false"
                [showCheckbox]="allowsMultipleStoreSelection"
                [showStoreIcon]="!allowsMultipleStoreSelection"
                [showActionButtons]="false"
                [showFreshnessIndicator]="true"
                [storesHeaderDropdown]="true"
                [placeholder]="'Select Stores'"
                [selected]="selectedStores"
                [setOptions]="getStoresAsISelectOptions()"
                [keyOrder]="getStoresKeyOrder()"
                [preserveOrder]="true"
                [stores]="getStoresAsRecord()"
                [dataTimeStampKey]="['stock']">
              </app-shared-custom-select>
            }
          </div>
        }

        <div class="banner-icons">

          <hr class="separator"/>

          @if (isMobile) {
            <div class="button-span">
              <div class="mobile-menu-btn" (click)="onMobileMenuClick()">
                @if (totalNotifications?.unreadFailed > 0) {
                  <div class="failed-notifications-badge">
                    <app-shared-badge
                      class="alert-badge"
                      [pulse]="true"
                      [value]="totalNotifications.unreadFailed">
                    </app-shared-badge>
                  </div>
                }
                <app-display-icon [icon]="icons.dotsVertical"></app-display-icon>
              </div>
            </div>
          } @else {
            @if (getUserName) {
              <div class="button-span">
                <app-display-icon
                  (click)="onProcessingQueueClick()"
                  [icon]="icons.progressClock"
                  [matTooltip]="'Processing queue'">
                </app-display-icon>
                <app-display-icon
                  (click)="toggleFullScreen()"
                  [icon]="!fullScreen ? icons.fullScreen: icons.fullScreenExit"
                  [matTooltip]="fullScreen ? 'Exit Full Screen': 'Full Screen'">
                </app-display-icon>
                <app-display-icon
                  (click)="onHardRefreshClick()"
                  [icon]="icons.sync"
                  [matTooltip]="hardRefreshTooltip">
                </app-display-icon>
                @if (getIsNotificationDataLoading) {
                  <app-display-icon
                    [icon]="icons.mail"
                    [tooltip]="'Notifications are loading.'">
                  </app-display-icon>
                } @else {
                  <app-display-icon
                    (click)="viewNotifications(true)"
                    [icon]="icons.bellOutline"
                    [tooltip]="notificationsTooltipUnreadAndUnsuccessful">
                  </app-display-icon>
                  @if (totalNotifications?.unreadFailed > 0) {
                    <div class="failed-notifications-badge">
                      <app-shared-badge
                        class="alert-badge"
                        [pulse]="totalNotifications.unreadFailed > 0"
                        [value]="totalNotifications.unreadFailed">
                      </app-shared-badge>
                    </div>
                  }
                  <app-shared-badge [value]="totalNotifications?.unread !== 0 ? totalNotifications?.unread : null"
                                    class="notifications-badge">
                    <app-display-icon
                      (click)="viewNotifications()"
                      class="mail-icon"
                      [icon]="icons.mail"
                      [tooltip]="notificationsTooltip">
                    </app-display-icon>
                  </app-shared-badge>
                  <div (click)="onFreshnessExpClick()">
                    <app-display-icon
                      [icon]="icons.infoSlabCircleOutline">
                    </app-display-icon>
                  </div>
                }
              </div>
            }

            <div (click)="getUserName? onOpenMenuClick($event): null" class="user-menu">
              @if (user?.pp) {
                <div class="menu-custom">
                  <img
                    [src]="getProfilePicture"
                    alt="Profile Picture"
                    class="profile-picture">
                </div>
              } @else {
                <div class="banner-icons">
                  <div class="button-span">
                    <app-display-icon
                      class="user-icon"
                      [icon]="icons.person">
                    </app-display-icon>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  @if (isMobile && selectedStoreName && !hideStoreSelector) {
    <div class="mobile-store-name">{{ selectedStoreName }}</div>
  }
</div>



